import { NgModule } from '@angular/core';
import { RouterModule, type Routes } from '@angular/router';
import { SettlementDailyPageComponent } from './settlement-daily-page/settlement-daily-page.component';
import { SettlementListPageComponent } from './settlement-list-page/settlement-list-page.component';
import { TransactionsListPageComponent } from './transactions-list-page/transactions-list-page.component';
import { TransactionDetailPageComponent } from '../transaction-detail-page/transaction-detail-page.component';
import { NewTransactionDetailGuard } from '../transaction-detail-page/new-transaction-detail.guard';
import { LegacyTransactionDetailPageComponent } from '../transaction-detail-page-legacy/transaction-detail-page-legacy.component';

export const routes: Routes = [
  { path: '', component: TransactionsListPageComponent },
  // first match wins: the rebuilt page when its feature is on, the legacy page otherwise
  {
    path: 'detail/:traceId',
    component: TransactionDetailPageComponent,
    canMatch: [NewTransactionDetailGuard],
  },
  { path: 'detail/:traceId', component: LegacyTransactionDetailPageComponent },
  // MVP only !!!
  { path: '', component: SettlementListPageComponent },
  { path: 'settlements', component: SettlementListPageComponent },
  { path: 'settlements/:date', component: SettlementDailyPageComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TransactionsLayoutRoutingModule { }
